import styled from "styled-components";

const TableRowCell = styled.td`
    width: ${(props: any) => props.width ? `${props.width}%` : 'auto'};
    max-width: 50px;
    vertical-align: middle;
`;

export default TableRowCell;